import { render, staticRenderFns } from "./ParticipantsList.vue?vue&type=template&id=297dc376&scoped=true&"
import script from "./ParticipantsList.vue?vue&type=script&lang=js&"
export * from "./ParticipantsList.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsList.vue?vue&type=style&index=0&id=297dc376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297dc376",
  null
  
)

export default component.exports